"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InflationIndexedPriceChange = class InflationIndexedPriceChange extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    id;
    onId(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("id");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    labelAlign;
    item;
    async $$load_item() {
        return this.$fn.fetch('read_notification', { parameters: { id: this.id }, asResource: true });
    }
    payload;
    async $$load_payload() {
        return {
            price: this.item.data.new_price,
            valid_from: this.item.data.source_object.valid_to || this.$fn.today(),
            valid_to: null,
            notes: null
        };
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['labelAlign', 'item', 'payload', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                item: null,
                payload: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Create new price"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2874_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_2880_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async act_1040167445267876_request_2878_getActionArgs($event) {
        return {
            operation: "update_notification",
            data: {
                id: this.item.id,
                $etag: this.item.$etag,
                state: 'handled',
                result_notes: this.payload.notes,
                result_data: this.payload
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_2882_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2874 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2874_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2873 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2874,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2873],
        });
        const act_2248226175642056_closeComponent_2876 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_2875 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_2876,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2875],
        });
        const act_1040167445267876_closeModal_2880 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_2880_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_2879 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_2880,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_2878 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_2878_getActionArgs,
            displayName: "update",
            events: [evh_1040167445267876_success_2879],
        });
        const evh_1040167445267876_submit_2877 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_2878,
            event: "submit",
            displayName: "update",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_2877],
        });
        const act_1419464017721962_closeModal_2882 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_2882_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_2881 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_2882,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_2881],
        });
        return {
            act_7315092382398562_closeModal_2874,
            evh_7315092382398562_close_2873,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_2876,
            evh_2248226175642056_close_2875,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_2880,
            evh_1040167445267876_success_2879,
            act_1040167445267876_request_2878,
            evh_1040167445267876_submit_2877,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_2882,
            evh_1419464017721962_clickPreventStop_2881,
            evh_1419464017721962_clickPreventStop,
            update: act_1040167445267876_request_2878,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], InflationIndexedPriceChange.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InflationIndexedPriceChange.prototype, "onId", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], InflationIndexedPriceChange.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InflationIndexedPriceChange.prototype, "onSize", null);
InflationIndexedPriceChange = __decorate([
    (0, vue_property_decorator_1.Component)()
], InflationIndexedPriceChange);
exports.default = InflationIndexedPriceChange;
vue_property_decorator_1.Vue.component("InflationIndexedPriceChange", InflationIndexedPriceChange);
